var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxTop"},[_c('h1',[_vm._v(_vm._s(_vm.obj.header))]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"card"},_vm._l((_vm.obj.arrCard),function(item,index){return _c('div',{key:index},[_c('p',[_vm._v(_vm._s(item.num))]),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }